module.exports = __webpack_public_path__ + "static/media/blank-profile-picture.f55316c4.jpg";